export const AUDIO_RECORDER_TRANSCRIBER_SAMPLE_RATE_HZ = 16_000;
export const AUDIO_RECORDER_TRANSCRIBER_LANGUAGE_CODE = "en_us";
export const AUDIO_RECORDER_TRANSCRIBER_WS_URL = "wss://streaming.assemblyai.com/v3/ws";
